import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import SignUpPopup from './EventSignup';
import { db } from '../../firebase';
import './Event.css';

function EventDetail() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [showSignUp, setShowSignUp] = useState(false);

  useEffect(() => {
    async function fetchEvent() {
      const docRef = doc(db, 'events', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setEvent({ id: docSnap.id, ...docSnap.data() });
      }
    }
    fetchEvent();
  }, [id]);

  if (!event) return <div>Loading...</div>;

  const dateObj = event.date && event.date.seconds
    ? new Date(event.date.seconds * 1000)
    : null;

  const day = dateObj ? dateObj.getDate() : '';
  const monthLong = dateObj ? dateObj.toLocaleString('default', { month: 'long' }) : '';
  const year = dateObj ? dateObj.getFullYear() : '';
  const hours = dateObj ? dateObj.getHours().toString().padStart(2, '0') : '';
  const minutes = dateObj ? dateObj.getMinutes().toString().padStart(2, '0') : '';
  const time = dateObj ? `${hours}:${minutes}` : '';

  return (
    <div className="event-detail-container">
      <div className="event-detail-image-section">
        <img src={event.image} alt={event.name} className="event-detail-image" />
      </div>
      <div className="event-detail-info-section">
        <h2 className="event-detail-title">{event.name}</h2>
        <p className="event-detail-description">{event.description}</p>
        <div className="event-detail-meta">
          {Number(event.costPerPerson) > 0 && (
            <div>
              <strong>Price:</strong><br />
              € {event.costPerPerson}
            </div>
          )}
          <div style={{ marginTop: 16 }}>
            <strong>Date & Time:</strong><br />
            {day} {monthLong} {year} {time && `| ${time}`}
          </div>
          <div style={{ marginTop: 16 }}>
            <strong>Location:</strong><br />
            {event.location}
          </div>
        </div>
        <button
          className="event-detail-signup-btn"
          onClick={() => setShowSignUp(true)}
        >
          Sign Up for Event
        </button>
      </div>
      {showSignUp && (
        <SignUpPopup
          event={event}
          onClose={() => setShowSignUp(false)}
        />
      )}
    </div>
  );
}

export default EventDetail;